module.exports = __webpack_public_path__ + "static/img/shop-start.295c5e29.png";